export const PLACE_ACTION_TYPE_LABELS = {
  PLACE_ACTION_TYPE_UNSPECIFIED: 'Unspecified',
  APPOINTMENT: 'Appointment',
  ONLINE_APPOINTMENT: 'Online Appointment',
  DINING_RESERVATION: 'Dining Reservation',
  FOOD_ORDERING: 'Food Ordering',
  FOOD_DELIVERY: 'Food Delivery',
  FOOD_TAKEOUT: 'Food Takeout',
  SHOP_ONLINE: 'Shop Online',
};
